import { render } from "./DraggableButtonGroup.vue?vue&type=template&id=885eba64&scoped=true"
import script from "./DraggableButtonGroup.vue?vue&type=script&lang=ts"
export * from "./DraggableButtonGroup.vue?vue&type=script&lang=ts"

import "./DraggableButtonGroup.vue?vue&type=style&index=0&id=885eba64&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-885eba64"

export default script